import api from "./api";
import { parsePaginatedList } from "../utils/pagination";

export type WarehouseType = "WAREHOUSE" | "STORE" | "OUTLET" | string;

export interface Warehouse {
  id: string;
  companyId: string;
  branchId?: string | null;
  name: string;
  code: string;
  type: WarehouseType;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  phone?: string | null;
  email?: string | null;
  managerUserId?: string | null;
  isActive: boolean;
  isDefault: boolean;
  createdAt?: string;
  updatedAt?: string;
  branch?: { id: string; name: string } | null;
}

export interface CreateWarehouseData {
  name: string;
  code?: string;
  type?: WarehouseType;
  branchId?: string | null;
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  phone?: string;
  email?: string;
  isActive?: boolean;
  isDefault?: boolean;
}

export type UpdateWarehouseData = Partial<CreateWarehouseData>;

const warehouseAPI = {
  getWarehouses: async (params?: {
    pageNo?: number;
    pageSize?: number;
    search?: string;
    city?: string;
    branchId?: string;
    type?: string;
    isActive?: boolean;
    sortBy?: string;
    sortOrder?: "ASC" | "DESC";
  }): Promise<{ data: Warehouse[]; total: number }> => {
    const response = await api.get("/warehouses", { params });
    const { data, total } = parsePaginatedList<Warehouse>(response.data.data);
    return { data, total };
  },

  getWarehouseById: async (id: string): Promise<Warehouse> => {
    const response = await api.get(`/warehouses/${id}`);
    return response.data.data;
  },

  createWarehouse: async (payload: CreateWarehouseData): Promise<Warehouse> => {
    const response = await api.post("/warehouses", payload);
    return response.data.data;
  },

  updateWarehouse: async (
    id: string,
    payload: UpdateWarehouseData
  ): Promise<Warehouse> => {
    const response = await api.put(`/warehouses/${id}`, payload);
    return response.data.data;
  },

  deleteWarehouse: async (id: string): Promise<void> => {
    await api.delete(`/warehouses/${id}`);
  },
};

export default warehouseAPI;
